module.exports = __webpack_public_path__ + "img/3a4289f.svg";